import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=080b889a&"
import script from "./Index.js?vue&type=script&lang=js&"
export * from "./Index.js?vue&type=script&lang=js&"
import style0 from "./Index.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports